import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/womens-health/content.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LEGACY_ENV_KEY"] */ "/app/src/app/components/LegacyEnvVariables/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/components/PageLayoutV3/index.tsx");
